<template>
  <div v-if="valueModel">
    <BFormTags
      v-model="valueModel.value"
      :placeholder="`${props.placeholder}${props.required ? ' *' : ''}`"
      :add-button-text="props.addButtonText"
      :duplicate-tag-text="props.duplicateTagText"
      :invalid-tag-text="props.invalidTagText"
      input-type="text"
      :tag-variant="props.tagVariant"
      :required="props.required"
      :tag-validator="props.tagValidator ? (tag: string) => (((valueModel?.value?.indexOf(tag)??-1) > -1) || props.tagValidator!(tag, valueModel?.value ?? [])) : undefined"
    />
    {{ errorMessage }}
  </div>
</template>
<script setup lang="ts">
import type { BaseColorVariant } from 'bootstrap-vue-next';
import { useField } from 'vee-validate';
import { computed } from 'vue';

const model = defineModel<string[] | undefined>({ required: false, default: () => [] });

const props = withDefaults(defineProps<{
  valueKey?: AllTypeKeys;
  placeholder?: string;
  addButtonText?: string;
  duplicateTagText?: string;
  invalidTagText?: string;
  tagVariant?: keyof BaseColorVariant;
  required?: boolean;
  tagValidator?: (tag: string, choices?: string[]) => boolean;
}>(), {
  placeholder: '',
  addButtonText: 'Ajouter',
  duplicateTagText: 'Choix déjà existant',
  invalidTagText: 'Choix déjà existant',
  tagVariant: 'secondary',
  required: false
})

const { value, errorMessage } = props.valueKey !== undefined ? useField<string[]>(() => props.valueKey!) : {};

const valueModel = computed(() => {
  if(props.valueKey) return value;
  else if(model.value !== undefined) return model;
  else return undefined;
})
</script>

<style>
  .b-form-tags small.form-text.text-body-secondary {
    color: var(--bs-form-invalid-color) !important;
  }
</style>
